<script setup lang="ts">
import {
  ErrorSnackbar,
  LanguageSelector,
  useUserStore
} from '@blueprint/frontend-basics'
import { onMounted, ref, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'

import { SafeArea } from 'capacitor-plugin-safe-area'
import { Capacitor } from '@capacitor/core'
import { type useServiceStore } from './stores/service.store'

const { t } = useI18n()
const userStore = useUserStore()
const serviceStore = inject<ReturnType<typeof useServiceStore>>('serviceStore')
const drawer = ref(false)
const statusBarHeight = ref<number>(0)
const isNative = Capacitor.isNativePlatform()

onMounted(async () => {
  try {
    const { statusBarHeight: height } = await SafeArea.getStatusBarHeight()
    statusBarHeight.value = height
  } catch (e) {
    // This might fail on web, so we just log the error
    console.error('Could not get status bar height from plugin', e)
  }
})
</script>

<template>
  <v-app>
    <v-system-bar v-if="isNative" :height="statusBarHeight" color="surface"></v-system-bar>
    <v-navigation-drawer app v-model="drawer" temporary>
      <v-list>
        <v-list-item :title="t('general.appName')"></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ t('general.appName') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular
        v-if="userStore.isLoading"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <v-btn
        v-else-if="userStore.isAnonymous && serviceStore"
        @click="serviceStore.authService.startLoginProcess()"
        data-cy="login-button"
        >{{ t('general.login') }}</v-btn
      >
      <v-btn v-else-if="serviceStore" @click="serviceStore.authService.logout()">{{ t('general.logout') }}</v-btn>
      <LanguageSelector />
    </v-app-bar>

    <v-main class="main">
      <router-view></router-view>
    </v-main>

    <ErrorSnackbar />
  </v-app>
</template>

<style scoped lang="scss"></style>
